import styled from "styled-components";

export const TextEtapa = styled.p`
  //styleName: SM/Medium;
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.01em;
`;

export const Body = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  margin: 0 12px;
  padding: 16px 16px 8px 16px;
  min-height: 353px;
  width: 271px;
  margin-bottom: 12px;
`;

export const TextStatus: any = styled.p`
  border-radius: 32px;
  padding: 4px 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 18px;

  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 15.6px;
  color: #ffffff;
  background-color: ${(props: any) => props.backgroundColor};
`;

export const StatusRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const StatusRowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CyrelaLogo = styled.img`
  width: 22px;
  height: 22px;
  object-fit: cover;
  border-radius: 50%;
`;

export const TextName: any = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${(props: any) => props.width || "150px"};
  white-space: nowrap;
`;

export const TextCodigo = styled.p`
  border-radius: 4px;
  padding: 0 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 23px;
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  color: #424248;
  background-color: #ececec;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TextStrong: any = styled.p`
  //styleName: SM/Medium;
  font-family: Inter;
  font-size: 13px;
  font-weight: 600;
  line-height: 14px;
  letter-spacing: -0.01em;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${(props: any) => props.width || "150px"};
  white-space: nowrap;
`;

export const TextFine: any = styled.p`
  //styleName: SM/Medium;
  //styleName: SM/Regular;
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.01em;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${(props: any) => props.width || "150px"};
  white-space: nowrap;
`;

export const TextWarning: any = styled.p`
  border-radius: 16px;
  padding: 0 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 18px;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 15.6px;
  color: ${(props: any) => props.textColor};
  background-color: ${(props: any) => props.color};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ResponsavelBadge = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 6px;
  border: 2px solid #2d5bff;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  padding: 0 10px;
  gap: 8px;
`;

export const ResponsavelText = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: #2d5bff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Button = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export const Divider = styled.div`
  border: 1px solid #d5d5d5;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px !important;
`;
